import {
  DataQuery,
  NumericFilter,
  StringFilter
} from "cartovista";

    function _updateDataRowsValues(dataTable, columnsNames, linkingIds, values, filter) {
        var dataColumns = dataTable.getDataColumns(columnsNames);
        _.forEach(dataColumns, function(dataColumn){
            dataTable.updateValues(dataColumn, linkingIds, values);
            if(filter){
                dataColumn.clearFilters();
                switch (filter.TYPE) {
                    case ("StringFilter"):
                        dataColumn.filters = [new StringFilter(filter.OPERATOR, filter.VALUE)];
                        break;
                    case ("NumericFilter"):
                        dataColumn.filters = [new NumericFilter(filter.OPERATOR, filter.VALUE)];
                        break;
                    default:
                        throw new Error("Filter._addFilter - type : " + filter.TYPE + " is invalid.");
                }
            }
        });
    };

    export function updateColumnsWithStoreValues(updateConfig) {
        var map = window.cartovista.externalInterface.map;
        var layer = map.getLayer(updateConfig.LAYER_ID);
        var dataTable = layer.getDataTable(updateConfig.DATATABLE_ID);

        return new Promise(function(resolve, reject) {
            new DataQuery([layer.featureIdDataColumn]).execute(function(queryResult) {
                if(queryResult.linkingIds.length == 0){
                    layer.addOneTimeEventListener(layer.EVENTS.FEATURES_ADDED, function(){ new DataQuery([layer.featureIdDataColumn]).execute(resolve);}, this);
                } else{
                    resolve(queryResult);
                }
            });
        }).then(function(queryResult) {
            switch (updateConfig.TYPE) {
                case "sum":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        return _.sumBy(items, function(item){
                            return item[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] ? (typeof item[updateConfig.STORE_VALUE.STORE_ATTRIBUTE][updateConfig.STORE_VALUE.SUB_STORE_ATTRIBUTE] != "undefined" ? item[updateConfig.STORE_VALUE.STORE_ATTRIBUTE][updateConfig.STORE_VALUE.SUB_STORE_ATTRIBUTE] : 0) : item.attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE];
                        });
                    });
                    break;
                case "count":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        return items.length;
                    });
                    break;
                case "count uniq":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        return _.uniqBy(items, function(item){
                            return item[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] ? item[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] : item.attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE];
                        }).length;
                    });
                    break;
                case "count notnull":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        items  = _.filter(items, function(item) {
                            return item.attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] !== null ? item.attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE]:null;
                        });
                        return items.length;
                    });
                    break;
                case "count uniq notnull":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        items  = _.filter(items, function(item) {
                            return item.attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] !== null ? item.attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE]:null;
                        });
                        return _.uniqBy(items, function(item){
                            return item[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] ? item[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] : item.attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE];
                        }).length;
                    });
                    break; 
                case "concat":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        return _.map(items, updateConfig.STORE_VALUE.STORE_ATTRIBUTE).join(", ");
                    });
                    break;
                case "concat uniq":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        return _.uniq(_.map(items, updateConfig.STORE_VALUE.STORE_ATTRIBUTE)).join(", ");
                        });
                    break; 
                case "value":
                    var values = _.map(queryResult.linkingIds, function(linkingId, idx) {
                        var filter = _.assign(updateConfig.JOIN.FILTER, {[updateConfig.JOIN.FILTER_KEY] : queryResult.values[layer.featureIdDataColumn.dataTable.id][layer.featureIdDataColumn.id][idx]});
                        var items = window[updateConfig.STORE].getItems(filter);
                        return items.length ? items[0].attributes[updateConfig.STORE_VALUE.STORE_ATTRIBUTE] : updateConfig.STORE_VALUE.DEFAULT_VALUE;
                    });
                    break;
            };
            _updateDataRowsValues(dataTable, updateConfig.DATACOLUMNS, queryResult.linkingIds, values, updateConfig.FILTER);
        });
    };
